(() => {
  const lightbox = document.getElementById('ByRavnPreviewLightbox');
  if (!lightbox || typeof lightbox.showModal !== 'function') return;

  const previewImage = lightbox.querySelector('.byravn-preview-lightbox__image');
  const closeButton = lightbox.querySelector('.byravn-preview-lightbox__close');

  // `shopify theme dev` rewrites cdn.shopify.com URLs in rendered HTML to a same-origin
  // /cdn/s/ path that 404s for /uploads/ files; live stores keep the absolute URL, which
  // this leaves untouched. Matched narrowly: only /cdn/s/ maps onto cdn.shopify.com by
  // dropping the prefix — /cdn/shop/ does not, and must be left alone.
  const absoluteCdnUrl = (href) => href.replace(/^\/cdn\/s\//, 'https://cdn.shopify.com/s/');

  const isPlainLeftClick = (event) =>
    !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

  const openPreview = (link) => {
    previewImage.src = absoluteCdnUrl(link.getAttribute('href'));
    lightbox.showModal();
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.byravn-preview-link');
    if (!link || !isPlainLeftClick(event)) return;
    event.preventDefault();
    openPreview(link);
  });

  // Dismiss only when the press both starts and ends on the backdrop. A `click` targets the
  // nearest common ancestor of its press and release, so testing the click alone treats a
  // drag between the image and the backdrop — an aborted drag, or selecting the image — as
  // a backdrop click and closes the viewer out from under the user.
  let pressStartedOnBackdrop = false;
  lightbox.addEventListener('pointerdown', (event) => {
    pressStartedOnBackdrop = event.target === lightbox;
  });
  lightbox.addEventListener('pointerup', (event) => {
    if (pressStartedOnBackdrop && event.target === lightbox) lightbox.close();
  });
  closeButton.addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('close', () => previewImage.removeAttribute('src'));

  // Dawn's CartDrawer and CartNotification close themselves on Escape *keyup*. Escape
  // dismisses this dialog on keydown, so without this the trailing keyup would reach the
  // drawer underneath and close that too — one press, two things closed.
  lightbox.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.addEventListener('keyup', (keyup) => keyup.key === 'Escape' && keyup.stopPropagation(), {
      capture: true,
      once: true,
    });
  });
})();
